import {Button, Checkbox, Col, Modal, Row} from "antd";
import React, {useEffect, useState} from "react";

export default (props) => {
    const [open, setOpen] = useState(false)
    const [values, setValues] = useState([])
    const [allColumns, setAllColumns] = useState([])
    const [loading, setLoading] = useState(false)

    const handleSave = (e) => {
        if (props.onSave) {
            props.onSave(values)
            props.onClose()
        }
    }

    useEffect(() => {
        setOpen(props.open)
        setAllColumns(props.allColumns)
        const defaultValues = []
        props.selectColumns.forEach((column) => {
            defaultValues.push(column.dataIndex)
        })
        setValues(defaultValues)

        return () => {
            if (loading)
                setLoading(false)
        }
    }, [props.open, props.selectColumns, props.allColumns])

    const getCheckBoxItems = () => {
        const layout = []
        {
            allColumns?.forEach((column) => {
                layout.push(
                    <Col span={24}>
                        <Checkbox value={column.dataIndex}>{column.title}</Checkbox>
                    </Col>
                )
            })
        }
        return layout
    }

    const onChange = (checkedValues) => {
        setValues(checkedValues)
    };

    return (
        <Modal title={"Manage Columns"} open={open} onCancel={props.onClose} footer={[
            <Button
                key="Save"
                type="primary"
                loading={loading}
                onClick={handleSave}
            >
                Save
            </Button>,
        ]}>
            <div style={{display: 'flex', gap: 2, flexDirection: 'column'}}>
                <p>Select the columns you'd like to see on this page</p>
                <Checkbox.Group onChange={onChange} value={values} style={{
                    width: '100%',
                }}>
                    <Row>
                        {getCheckBoxItems()}
                    </Row>
                </Checkbox.Group>
            </div>
        </Modal>
    )
}